import React, { FC, ReactNode, useMemo } from "react";
import { useAtom } from "jotai/index";
import classNames from "classnames";

import { NamedInput } from "components/NamedInput/NamedInput";
import { NamedSelect } from "components/NamedSelect/NamedSelect";
import { Option } from "components/Select/Select";
import { Divider } from "components/Divider/Divider";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";

import { openedDocItemStateAtom } from "../../../atoms/documentsAtom";
import { allItemsAtom } from "../../../atoms/itemAtom";
import { measureUnitsAtom } from "../../../atoms/measureUnitsAtom";

import styles from "../styles.module.scss";
interface ComponentProps {}

const ElementContainer = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  return <div className={styles.componentContainer}>{children}</div>;
};

export const DocItemModal3: FC<ComponentProps> = ({}): JSX.Element => {
  const [allItems] = useAtom(allItemsAtom);
  const [measureUnits] = useAtom(measureUnitsAtom);
  const [openedDocItemState, setOpenedDocumentState] = useAtom(
    openedDocItemStateAtom
  );

  const itemsOptions: Option[] = useMemo(
    () =>
      allItems.map((i) => ({ value: i.itemid, label: i.longname || i.name })),
    [allItems]
  );

  const measureUnitsOptions: Option[] = useMemo(
    () => measureUnits.map((i) => ({ value: i.measureid, label: i.name })),
    [measureUnits]
  );

  const itemVal: Option | undefined = useMemo(
    () =>
      itemsOptions.find((i) => +i.value === Number(openedDocItemState.itemid)),
    [itemsOptions, openedDocItemState.itemid]
  );

  const measureUnitVal: Option | undefined = useMemo(
    () =>
      measureUnitsOptions.find(
        (i) => +i.value === Number(openedDocItemState.measureid)
      ),
    [measureUnitsOptions, openedDocItemState.measureid]
  );

  const handleItem = (val) => {
    setOpenedDocumentState({
      itemid: val?.value,
      measureid:
        allItems.find((i) => i.itemid === val?.value)?.measureid || null,
    } as any);
  };

  const handleAmount = (ev) => {
    const objToUpdate: any = { amount: ev.target.value };

    setOpenedDocumentState(objToUpdate as any);
  };

  return (
    <div className={styles.wrapper}>
      <ElementContainer>
        <NamedSelect
          options={itemsOptions}
          name={"Товар"}
          nameClassName={styles.inputName}
          className={styles.itemSelect}
          value={itemVal}
          onChange={handleItem}
          placeholder={"Выберите товар"}
        />
      </ElementContainer>
      <div className={styles.inputsRow}>
        <ElementContainer>
          <NamedSelect
            options={measureUnitsOptions}
            name={"Ед. изм"}
            nameClassName={styles.inputName}
            value={measureUnitVal}
            onChange={(val) =>
              setOpenedDocumentState({ measureid: val?.value } as any)
            }
            placeholder={"Выберите ед. изм"}
          />
        </ElementContainer>
      </div>
      <VerticalSpace size={40} />
      <Divider />
      <VerticalSpace size={40} />

      <ElementContainer>
        <NamedInput
          label={"Кол-во"}
          type={"number"}
          labelClassName={classNames(
            styles.inputName,
            styles.inputNameMarginRight
          )}
          isLabelRegular
          value={openedDocItemState.amount || ""}
          onChange={handleAmount}
        />
      </ElementContainer>

      <VerticalSpace size={100} />
    </div>
  );
};
